import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { isAuthConfigured } from '@/config/environment';

/**
 * Admin sign-in. Azure Entra ID via MSAL redirect — only accounts in the
 * site's tenant can authenticate.
 */
export function PortalLogin() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) navigate('/portal', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <Flex minH="100vh" align="center" justify="center" bg="brand.wash" direction="column" gap="2rem" px="1.8rem">
      <Box textAlign="center">
        <Heading fontFamily="heading" fontSize="clamp(2.4rem, 4vw, 3.4rem)" fontWeight="300" color="brand.ink" mb="0.6rem">
          Site{' '}
          <Box as="em" fontStyle="italic" color="brand.mid">
            Portal Access
          </Box>
        </Heading>
        <Text fontFamily="heading" fontStyle="italic" fontSize="1.05rem" color="ink.soft">
          Sign in with your Microsoft account to manage the site.
        </Text>
      </Box>

      {isAuthConfigured() ? (
        <Box
          as="button"
          onClick={() => instance.loginRedirect({ scopes: ['openid', 'profile'] })}
          bg="brand.mid"
          color="paper.white"
          fontFamily="body"
          fontSize="0.72rem"
          fontWeight="500"
          letterSpacing="0.15em"
          textTransform="uppercase"
          px="2.8rem"
          py="1rem"
          border="none"
          cursor="pointer"
          borderRadius="24px"
          transition="background 0.2s, transform 0.2s"
          _hover={{ bg: 'brand.ink', transform: 'translateY(-1px)' }}
        >
          Sign in with Microsoft →
        </Box>
      ) : (
        <Box bg="paper.white" border="1px solid" borderColor="brand.pale" borderRadius="12px" px="1.6rem" py="1.2rem" maxW="480px">
          <Text fontSize="0.87rem" color="ink.soft" lineHeight="1.7">
            Azure Entra ID is not configured. Run <code>pnpm env:load</code> to populate
            VITE_AZURE_AD_CLIENT_ID and VITE_AZURE_AD_TENANT_ID from Key Vault, or see
            infrastructure/scripts/setup-azure-ad-app.sh.
          </Text>
        </Box>
      )}
    </Flex>
  );
}
